/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import translation function for language translation
import { useTranslation } from "react-i18next";

import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "moment/locale/es";
import "moment/locale/ca";
import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = momentLocalizer(moment);

const HolidayCalendarBody = () => {
  const token = localStorage.getItem("token"); // token

  const { t, i18n } = useTranslation(); // translation, language selection

  // Set moment locale based on i18n language
  useEffect(() => {
    if (i18n.language === "es") {
      moment.locale("es");
    } else if (i18n.language === "ca") {
      moment.locale("ca");
    } else {
      moment.locale("en");
    }
  }, [i18n.language]);

  // Calendar messages for localization
  const calendarMessages = {
    es: {
      date: "Fecha",
      time: "Hora",
      event: "Evento",
      allDay: "Todo el día",
      week: "Semana",
      work_week: "Semana laboral",
      day: "Día",
      month: "Mes",
      previous: "Anterior",
      next: "Siguiente",
      yesterday: "Ayer",
      tomorrow: "Mañana",
      today: "Hoy",
      agenda: "Agenda",
      noEventsInRange: "No hay eventos en este rango.",
    },
    ca: {
      date: "Data",
      time: "Hora",
      event: "Esdeveniment",
      allDay: "Tot el dia",
      week: "Setmana",
      work_week: "Setmana laboral",
      day: "Dia",
      month: "Mes",
      previous: "Anterior",
      next: "Següent",
      yesterday: "Ahir",
      tomorrow: "Demà",
      today: "Avui",
      agenda: "Agenda",
      noEventsInRange: "No hi ha esdeveniments en aquest rang.",
    },
    en: {},
  };

  const {
    reloadHolidayCalendar,
    setReloadHolidayCalendar,
    setEditHolidayCalendarData,
  } = useContext(GlobalProvider);

  // default user data ------------------------------------
  const [calendarData, setCalendarData] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);

  // get json data about date ------------------------------
  const currentYear = new Date().getFullYear();

  const parseAdjust = (eventDate) => {
    const date = new Date(eventDate);
    return date;
  };

  // function for get all calendar data
  const getAllCalendarData = async () => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_HOLIDAY_SCHEDULE + `?token=${token}`;

      console.log("Url of holiday list========>", requestUrl);

      const response = await getData(requestUrl);

      console.log(`response in calender list ==============>`, response.data);
      if (response.status) {
        setCalendarData(response.data);
        setResponseReceived(true);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const displayDate = new Date();

  // set response to match kendo scheduler event schema --------------------------------
  const kendoCalendarData = calendarData.map((dataItem) => ({
    id: dataItem._id,
    start: parseAdjust(dataItem.start, dataItem.starttime),
    end: parseAdjust(dataItem.end, dataItem.endtime),
    isAllDay: false,
    title: dataItem.title,
    description: dataItem.description,
    ownerId: dataItem.availability,
    date: dataItem.date,
    availability: dataItem.availability,
    starttime: dataItem.starttime,
    endtime: dataItem.endtime,
  }));

  /*---------- Handel Edit Calendar Schedule data ------------*/
  const scheduleItemHandler = (event) => {
    console.log("Clicked Event -->", event.resource);

    //assign schedule date in context
    setEditHolidayCalendarData(event.resource);

    const offcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("addHolidaySchedulePopup")
    );
    offcanvas.show();
  };

  /* hook to reload list */
  useEffect(() => {
    if (reloadHolidayCalendar) {
      getAllCalendarData();
      setReloadHolidayCalendar(false);
    }
  }, [reloadHolidayCalendar]);

  useEffect(() => {
    if (responseReceived === false) {
      getAllCalendarData();
    }
  }, [responseReceived]);

  return (
    <Calendar
      localizer={localizer}
      events={(kendoCalendarData || []).map((ev) => ({
        title: ev.title || "",
        start: new Date(ev.start),
        end: new Date(ev.end),
        resource: ev,
      }))}
      startAccessor="start"
      endAccessor="end"
      style={{ height: 600 }}
      views={["month", "week", "day", "agenda"]}
      defaultView="month"
      onSelectEvent={scheduleItemHandler}
      messages={calendarMessages[i18n.language] || calendarMessages.en}
    />
  );
};

export default HolidayCalendarBody;
